import ListContext from '../../../../shared/components/utils/context/listContext';
import Props from '../../../../shared/types/props/button';
import Record from '../../atoms/buttons/modalRecording';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { useContext } from 'react';
import { useAppSelector } from '../../../../shared/store/hooks';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';

function RecordButton({ index, literal, releaseAction }: Props) {
  const { listIndex } = useContext(ListContext);
  const { enabled } = useAppSelector(magicRemoteSelector);
  return (
    <Record focused={!enabled && listIndex === index} onClick={releaseAction}>
      {literal && TranslationManager.get(literal)}
    </Record>
  );
}

export default RecordButton;
